<section class="ch0">
    <section class="visu-zone">
        <ng-content select="[visu-zone]"></ng-content>
    </section>
</section>
